import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Order } from '../models/Order.model';
import { environment } from '../../environments/environment';
import { OrderTracking } from '../models/tracking.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private apiUrl = environment.apiBaseUrl +'/api/orders';

  constructor(private http: HttpClient) { }

  // ✅ Place a new order
  placeOrder(order: Order): Observable<Order> {
    return this.http.post<Order>(`${this.apiUrl}/create`, order);
  }

  // ✅ Get all orders (for admin or order history)
  getOrders(): Observable<Order[]> {
    return this.http.get<Order[]>(this.apiUrl);
  }

  // ✅ Get order by ID (for confirmation page)
  getOrderById(id: number): Observable<Order> {
    return this.http.get<Order>(`${this.apiUrl}/${id}`);
  }

  getOrdersByRole(role: string | null): Observable<any[]> {
    // Backend can filter by role (Admin = all, Vendor = vendor-specific)
    return this.http.get<any[]>(`${this.apiUrl}/get-orders-by-role?role=${role}`);
  }

  //getOrderTracking(orderId: number) {
  //  return this.http.get(`/api/orders/tracking/${orderId}`);
  //}

  // Customer: track order
  trackOrder(orderId: string | number): Observable<OrderTracking> {
    return this.http.get<OrderTracking>(`${this.apiUrl}/tracking/${orderId}`);
  }

  // Admin: get list of orders
  getAllOrders(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/get-orders`);
  }


  // Admin: get single order tracking details (re-use track)
  getOrderTracking(orderId: string | number): Observable<OrderTracking> {
    return this.trackOrder(orderId);
  }

  updateOrderStatus(orderId: number, payload: any) {
    return this.http.post(`${this.apiUrl}/${orderId}/status`, payload);
  }

  getCustomerOrders() {
    return this.http.get<any[]>(`${this.apiUrl}/my-order`);
  }

  markOrderPaid(orderId: number) {
    return this.http.post(
      `${this.apiUrl}/mark-paid/${orderId}`,
      {}
    );
  }
}
